/** Offsets use JavaScript UTF-16 indices into the literal message text. */
export interface ChatMention {
  chatId: string;
  title: string;
  start: number;
  end: number;
}

export interface MentionableChat { id: string; title: string }
export const MAX_CHAT_MENTIONS = 2;

/** A typed @ without an explicit selection remains ordinary text. */
export function validateChatMentions(value: unknown, text: string): ChatMention[] | null {
  if (value === undefined) return [];
  if (!Array.isArray(value) || value.length > MAX_CHAT_MENTIONS) return null;
  const result: ChatMention[] = [];
  for (const item of value) {
    if (!item || typeof item !== 'object' || Array.isArray(item)
      || Object.keys(item).some(key => !['chatId', 'title', 'start', 'end'].includes(key))
      || typeof item.chatId !== 'string' || !/^[A-Za-z0-9_-]{1,128}$/.test(item.chatId)
      || typeof item.title !== 'string' || !item.title.trim() || item.title.length > 140
      || [...item.title].some(character => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)
      || !Number.isInteger(item.start) || !Number.isInteger(item.end)
      || item.start < (result.at(-1)?.end ?? 0) || item.end <= item.start || item.end > text.length
      || text.slice(item.start, item.end) !== `@${item.title}`) return null;
    result.push({ chatId: item.chatId, title: item.title, start: item.start, end: item.end });
  }
  return result;
}
